module.exports = __webpack_public_path__ + "img/zx5.e921ac00.png";